export const COMMUNITY_LOADING = "COMMUNITY_LOADING";
export const COMMUNITY_LOADED = "COMMUNITY_LOADED";

export const GET_USER_COMMUNITY_LIST = "GET_USER_COMMUNITY_LIST";

export const GET_USER_GROUP_LIST = "GET_USER_GROUP_LIST";
export const GET_GROUP_DETAILS = "GET_GROUP_DETAILS";
export const GET_USER_GROUP_DETAILS = "GET_USER_GROUP_DETAILS";

export const DO_EMPTY_COMMUNITY_BY_USER_STATE = "DO_EMPTY_COMMUNITY_BY_USER_STATE";